import { buildAction } from 'store/actions/actionCreator'

import { FETCH_STORES } from './constants'

export const fetchStores = buildAction(FETCH_STORES, 'payload')
